<router-outlet></router-outlet>
<p-toast
  showTransitionOptions="250ms ease-in"
  showTransformOptions="translateX(100%)"
  hideTransformOptions="translateX(100%)"
  hideTransitionOptions="50ms linear"
></p-toast>
<app-alert-pop-up></app-alert-pop-up>